import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import ReplayIcon from '@material-ui/icons/Replay';
import axios from 'axios';
import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import PartidaArancelariaHistorialView from '../admin/pages/formulario/PartidaArancelariaHistorialView';
import PartidaArancelariaSearchView from '../admin/pages/formulario/PartidaArancelariaSearchView';
import PartidaArancelariaView from '../admin/pages/formulario/PartidaArancelariaView';
import PartidasArancelariasService from '../services/PartidasArancelariasService';

const styles = {
  dialogPaper: {
    minHeight: '95vh'
  }
};

const TabPanel = props => {
  const { children, value, index, loading, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {loading && (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <Fade
            in={props.loading}
            style={{
              transitionDelay: props.loading ? '800ms' : '0ms'
            }}
            unmountOnExit
          >
            <CircularProgress />
          </Fade>
        </div>
      )}
      {!loading && value === index && children}
    </div>
  );
};

const PartidaArancelariaSelector = ({ open, onClose, onChange, classes }) => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentValue, setCurrentValue] = useState();
  const [searchValue, setSearchValue] = useState('');
  const [searchValueHistorial, setSearchValueHistorial] = useState('');
  const [misMercaderias, setMisMercaderias] = useState(true);
  const [source, setSource] = useState();

  // nuevo
  const [expanded, setExpanded] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSearchHistorial, setLoadingSearchHistorial] = useState(false);
  const [debouncingSearch, setDebouncingSearch] = useState(false);
  const [debouncingSearchHistorial, setDebouncingSearchHistorial] = useState(
    false
  );
  const [partidasArancelarias, setPartidasArancelarias] = useState([]);
  const [
    partidasArancelariasHistorial,
    setPartidasArancelariasHistorial
  ] = useState([]);
  const [capitulos, setCapitulos] = useState([]);
  // const [open, setOpen] = useState([]);

  const [value, setValue] = useState(0);

  // const handleSelect = (event, nodeIds) => {
  //   setSelected(nodeIds);
  // };

  const SEPARADOR = '==========================';
  const mapPartidas = cap => {
    const newCap = { ...cap };
    const infoSplit = cap.nombreTecnico.split(SEPARADOR);
    const [nombre, info] = infoSplit;
    newCap.nombreResumido = nombre;
    newCap.info = info;
    if (!cap.esHoja) {
      newCap.children = [];
    }
    return newCap;
  };

  const mapTreeView = cap => {
    return {
      name: `${cap.codigo}${cap.esHoja ? cap.digitoVerificador || '' : ''}. ${
        cap.nombreResumido
      }`,
      info: cap.info,
      id: `${cap.codigo}`,
      children: cap.children?.map(mapTreeView),
      isLeaf: cap.esHoja,
      isLoading: cap.isLoading,
      disabled: cap.disabled
    };
  };

  const transformArray = arr => {
    if (arr.length === 0) return [];

    const transformedArray = arr
      .map((item, index) => {
        if (index === 0) {
          return {
            ...item,
            children: transformArray(arr.slice(1))
          };
        }
        return null;
      })
      .filter(item => item !== null);

    return transformedArray;
  };

  const mapPartidasHistorial = item => ({
    title: item.descripcion || '',
    subtitle: `${item.codigo}${
      item.esHoja ? item.digitoVerificador || '' : ''
    }. ${item.nombreTecnico}`,
    detail: (
      <>
        <PartidaArancelariaView
          readOnly
          expanded={item.padres.map(
            partidaArancelaria => `${partidaArancelaria.codigo}`
          )}
          data={transformArray(item.padres.map(mapPartidas).map(mapTreeView))}
        />
      </>
    ),
    value: mapPartidas({ ...item, id: item.idPartida })
  });

  const mapPartidasJerarquia = React.useCallback(cap => {
    const newCap = { ...cap };
    const infoSplit = cap.nombreTecnico.split(SEPARADOR);
    const [nombre, info] = infoSplit;
    newCap.nombreResumido = nombre;
    newCap.info = info;
    newCap.children = newCap.children.map(mapPartidasJerarquia);
    if (cap.esHoja) {
      delete newCap.children;
    }
    return newCap;
  }, []);

  /**
   * Busca el ítem recursivamente y lo actualiza
   * @param {*} codigo Código del item que se busca para actualizar
   * @param {*} item Item actual de dentro del árbol
   * @param {*} newData Nuevos datos a ser actualizados al encontrar el ítem
   * @returns Un nuevo árbol con el ítem actualizado
   */
  const actualizarItem = (codigo, item, newData) => {
    if (codigo === item.codigo) {
      return { ...item, ...newData };
    }
    if (!item.esHoja) {
      return {
        ...item,
        children: item.children.map(child =>
          actualizarItem(codigo, child, newData)
        )
      };
    }
    return item;
  };

  const buscarNodoPorCodigo = (nodos, codigo, padres) => {
    // Recorre cada nodo en el array
    for (const nodo of nodos) {
      // Comprueba si el código coincide
      if (nodo.codigo === codigo) {
        nodo.padres = padres.map(padre => ({ ...padre, children: undefined }));
        return nodo; // Si coincide, devuelve el nodo
      }
      // Si el nodo tiene hijos, busca recursivamente en esos hijos
      if (nodo.children && nodo.children.length > 0) {
        const resultado = buscarNodoPorCodigo(nodo.children, codigo, [
          ...padres.map(padre => ({ ...padre, children: undefined })),
          nodo
        ]);
        // Si se encontró el nodo en los hijos, devuelve el resultado
        if (resultado) {
          return resultado;
        }
      }
    }
    // Si no se encuentra el nodo con el código especificado, devuelve null
    return null;
  };

  const obtenerCapitulos = React.useCallback(
    () => {
      if (source) {
        source.cancel('Operation canceled by the user.');
        // commit('SET_LOADING_CAPITULOS', false);
      }
      const { CancelToken } = axios;
      const localSource = CancelToken.source();
      setSource(localSource);
      return PartidasArancelariasService.getCapitulos({
        cancelToken: localSource.token
      })
        .then(response => {
          setPartidasArancelarias(response.data.data.map(mapPartidas));
          setCapitulos(response.data.data.map(mapPartidas));
        })
        .catch(err => {
          throw err;
        });
    },
    [source]
  );

  const obtenerHistorial = React.useCallback(
    (descripcion, misMercaderiasParam) => {
      if (source) {
        source.cancel('Operation canceled by the user.');
      }
      const { CancelToken } = axios;
      const localSource = CancelToken.source();
      setSource(localSource);
      return PartidasArancelariasService.getHistorial(
        descripcion,
        misMercaderiasParam,
        {
          cancelToken: localSource.token
        }
      );
    },
    [source]
  );
  function buildHierarchy(items, pathAttribute) {
    const roots = {};

    function addNode(node, pathParts, item) {
      if (pathParts.length === 0) {
        Object.assign(node, item); // Conservar las propiedades del objeto original
        return;
      }
      const part = pathParts.shift();
      let childNode = node.children.find(child => child.codigo === part);
      if (!childNode) {
        childNode = { codigo: part, children: [] };
        node.children.push(childNode);
      }
      addNode(childNode, pathParts, item);
    }

    items.forEach(item => {
      const path = item[pathAttribute];
      const pathParts = path.split('/').filter(Boolean);

      const rootCode = pathParts.shift();
      let rootNode = roots[rootCode];
      if (!rootNode) {
        rootNode = { codigo: rootCode, children: [] };
        roots[rootCode] = rootNode;
      }
      addNode(rootNode, pathParts, item);
      if (!rootNode.hasOriginalProps) {
        Object.assign(rootNode, item); // Conservar las propiedades del objeto original para la raíz
        rootNode.hasOriginalProps = true;
      }
    });

    // eslint-disable-next-line no-param-reassign
    Object.values(roots).forEach(root => delete root.hasOriginalProps);

    return Object.values(roots);
  }

  const buscarCodigosConHijos = useCallback((items, codigos) => {
    items.forEach(item => {
      if (item.children && item.children.length > 0) {
        codigos.push(item.codigo);
        buscarCodigosConHijos(item.children, codigos);
      }
    });
  }, []);

  const obtenerCodigosConHijos = useCallback(
    data => {
      const codigos = [];
      buscarCodigosConHijos(data, codigos);
      return codigos;
    },
    [buscarCodigosConHijos]
  );

  const buscar = React.useCallback(
    busqueda => {
      if (source) {
        source.cancel('Operation canceled by the user.');
      }
      const { CancelToken } = axios;
      const localSource = CancelToken.source();
      setSource(localSource);

      return PartidasArancelariasService.search(busqueda, {
        cancelToken: localSource.token
      }).then(response => {
        const hierarchy = buildHierarchy(response.data, 'path');
        setExpanded(obtenerCodigosConHijos(hierarchy));
        setPartidasArancelarias(hierarchy.map(mapPartidasJerarquia));
      });
    },
    [mapPartidasJerarquia, obtenerCodigosConHijos, source]
  );

  const obtenerHijos = codigo => {
    setPartidasArancelarias(prev =>
      prev.map(item => actualizarItem(codigo, item, { isLoading: true }))
    );
    return (
      PartidasArancelariasService.getChildren(codigo)
        // .then(r => r.json())
        .then(response => {
          const children = response.data;
          const partidasHijas = children.data.map(mapPartidas);
          setPartidasArancelarias(prev =>
            prev.map(item =>
              actualizarItem(codigo, item, {
                isLoading: false,
                children: partidasHijas
              })
            )
          );
          return children;
        })
        .catch(err => {
          setPartidasArancelarias(prev =>
            prev.map(item => actualizarItem(codigo, item, { isLoading: false }))
          );
          throw err;
        })
    );
  };

  const handleToggle = (_, nodeIds) => {
    if (nodeIds.length > 0) {
      for (let i = 0; i < nodeIds.length; i += 1) {
        const element = nodeIds[i];

        const itemEncontrado = buscarNodoPorCodigo(
          partidasArancelarias,
          element,
          []
        );

        if (itemEncontrado && itemEncontrado.children?.length === 0) {
          // Si tiene hijos y aun no se han traido
          obtenerHijos(element);
        }
      }
    }
  };

  const handleToggleJerarquia = (_, nodeIds) => {
    if (nodeIds.length > 0) {
      for (let i = 0; i < nodeIds.length; i += 1) {
        const element = nodeIds[i];

        if (expanded.find(item => item === element)) {
          setExpanded(prev => prev.filter(v => v !== element));
        } else {
          setExpanded(prev => [...prev, element]);
        }

        const itemEncontrado = buscarNodoPorCodigo(
          partidasArancelarias,
          element,
          []
        );

        if (itemEncontrado && itemEncontrado.children?.length === 0) {
          // Si tiene hijos y aun no se han traido
          obtenerHijos(element);
        }
      }
    }
  };

  const handleHistorySelect = (item, descripcion, detalle) => {
    onChange(item, descripcion, detalle);
    onClose();
  };

  const selectPartida = item => {
    if (item.esHoja) {
      const detalles = (
        <>
          <PartidaArancelariaView
            readOnly
            expanded={item.padres.map(
              partidaArancelaria => `${partidaArancelaria.codigo}`
            )}
            data={transformArray(
              [...item.padres, item].map(mapPartidas).map(mapTreeView)
            )}
          />
        </>
      );
      onChange(item, undefined, detalles);
      onClose();
    }
  };

  const handleSelect = (_, nodeId) => {
    const itemEncontrado = buscarNodoPorCodigo(
      partidasArancelarias,
      nodeId,
      []
    );
    if (itemEncontrado.esHoja) {
      selectPartida(itemEncontrado);
    } else {
      handleToggleJerarquia(null, [nodeId]);
    }
  };

  const onBusquedaChange = React.useCallback(
    val => {
      setDebouncingSearch(false);
      if (val) {
        setLoadingSearch(true);
        buscar(val).then(
          () => setLoadingSearch(false),
          () => setLoadingSearch(false)
        );
      } else {
        setLoadingSearch(false);
        setPartidasArancelarias(capitulos);
      }
    },
    [buscar, capitulos]
  );

  const onBusquedaHistorialChange = React.useCallback(
    (val, misMercaderiasParam) => {
      setDebouncingSearchHistorial(false);
      if (val) {
        setLoadingSearchHistorial(true);
        obtenerHistorial(val, misMercaderiasParam)
          .then(response => {
            setPartidasArancelariasHistorial(response.data);
            setLoadingSearchHistorial(false);
          })
          .catch(err => {
            setLoadingSearchHistorial(false);
            throw err;
          });
      } else {
        setLoadingSearchHistorial(true);
        obtenerHistorial(undefined, misMercaderiasParam)
          .then(response => {
            setPartidasArancelariasHistorial(response.data);
            setLoadingSearchHistorial(false);
          })
          .catch(err => {
            setLoadingSearchHistorial(false);
            throw err;
          });
      }
    },
    [obtenerHistorial]
  );

  const onBusquedaChangeDebunced = React.useMemo(
    () => {
      return debounce(onBusquedaChange, 500);
    },
    [onBusquedaChange]
  );

  const onBusquedaHistorialChangeDebunced = React.useMemo(
    () => {
      return debounce(onBusquedaHistorialChange, 500);
    },
    [onBusquedaHistorialChange]
  );

  const handleBusquedaChange = val => {
    setSearchValue(val);
    setPartidasArancelarias([]);
    if (val === '' || val.length >= 3) {
      setDebouncingSearch(true);
      onBusquedaChangeDebunced(val);
    }
  };

  const handleBusquedaHistorialChange = val => {
    setSearchValueHistorial(val);
    setPartidasArancelariasHistorial([]);
    setDebouncingSearchHistorial(true);
    onBusquedaHistorialChangeDebunced(val, misMercaderias);
  };

  const handleBusquedaHistorialChangeMisMercaderias = misMercaderiasParam => {
    setMisMercaderias(misMercaderiasParam);
    setPartidasArancelariasHistorial([]);
    setDebouncingSearchHistorial(true);
    onBusquedaHistorialChangeDebunced(
      searchValueHistorial,
      misMercaderiasParam
    );
  };

  useEffect(() => {
    obtenerCapitulos();

    setLoadingSearchHistorial(true);
    obtenerHistorial(undefined, true)
      .then(response => {
        setPartidasArancelariasHistorial(response.data);
        setLoadingSearchHistorial(false);
      })
      .catch(err => {
        setLoadingSearchHistorial(false);
        throw err;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog
      maxWidth="lg"
      open={open}
      scroll="paper"
      fullWidth
      fullScreen={isPhone}
      onClose={onClose}
      classes={
        isPhone
          ? {}
          : {
              paper: classes.dialogPaper
            }
      }
      onEnter={() => {
        setCurrentValue(undefined);
        setSearchValue('');
      }}
    >
      <DialogTitle style={{ padding: '8px 24px' }}>
        <Grid
          container
          wrap="nowrap"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs zeroMinWidth>
            <Typography noWrap>
              {currentValue ? `${currentValue.label}` : 'Seleccione la partida'}
            </Typography>
          </Grid>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              obtenerCapitulos();
              setLoadingSearchHistorial(true);
              obtenerHistorial(undefined, misMercaderias)
                .then(response => {
                  setPartidasArancelariasHistorial(response.data);
                  setLoadingSearchHistorial(false);
                })
                .catch(err => {
                  setLoadingSearchHistorial(false);
                  throw err;
                });
              setSearchValue('');
              setSearchValueHistorial('');
            }}
            startIcon={<ReplayIcon />}
          >
            Recargar listas
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" justifyContent="center" alignItems="center">
          <ButtonGroup
            color="primary"
            aria-label="outlined primary button group"
          >
            <Button
              onClick={() => setValue(0)}
              variant={value === 0 && 'contained'}
            >
              Recientes
            </Button>
            <Button
              onClick={() => setValue(1)}
              variant={value === 1 && 'contained'}
            >
              Lista completa
            </Button>
          </ButtonGroup>
        </Box>
        <br />
        <Grid
          container
          style={{
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingBottom: '16px'
          }}
        >
          {value === 0 && (
            <>
              <TextField
                autoFocus
                label="Buscar recientes"
                placeholder="La búsqueda aplica sobre la descripción de las mercaderías"
                variant="outlined"
                value={searchValueHistorial}
                onChange={event =>
                  handleBusquedaHistorialChange(event.target.value)
                }
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={
                  searchValueHistorial
                    ? {
                        endAdornment: (
                          <IconButton
                            onClick={() => handleBusquedaHistorialChange('')}
                          >
                            <ClearIcon />
                          </IconButton>
                        )
                      }
                    : null
                }
              />
              <div
                style={{
                  paddingTop: '16px'
                }}
              >
                <Chip
                  label="Mis mercaderías"
                  variant="outlined"
                  onClick={() =>
                    handleBusquedaHistorialChangeMisMercaderias(true)
                  }
                  color={misMercaderias ? 'primary' : 'default'}
                  style={{
                    marginRight: 8
                  }}
                  icon={misMercaderias ? <DoneIcon /> : undefined}
                />
                <Chip
                  label="Todas las mercaderías"
                  variant="outlined"
                  onClick={() =>
                    handleBusquedaHistorialChangeMisMercaderias(false)
                  }
                  color={!misMercaderias ? 'primary' : 'default'}
                  icon={misMercaderias ? undefined : <DoneIcon />}
                />
              </div>
            </>
          )}
          {value === 1 && (
            <TextField
              autoFocus
              label="Buscar en el listado completo"
              placeholder="La búsqueda aplica sobre el nombre técnico de la partida arancelaria"
              variant="outlined"
              value={searchValue}
              onChange={event => handleBusquedaChange(event.target.value)}
              fullWidth
              InputLabelProps={{
                shrink: true
              }}
              InputProps={
                searchValue
                  ? {
                      endAdornment: (
                        <IconButton onClick={() => handleBusquedaChange('')}>
                          <ClearIcon />
                        </IconButton>
                      )
                    }
                  : null
              }
              error={searchValue !== '' && searchValue.length < 3}
              helperText="Como mínimo debe ingresar 3 caractéres"
            />
          )}
        </Grid>
        <TabPanel
          value={value}
          index={0}
          loading={loadingSearchHistorial || debouncingSearchHistorial}
        >
          <PartidaArancelariaHistorialView
            items={partidasArancelariasHistorial.map(mapPartidasHistorial)}
            onChange={handleHistorySelect}
            highlight={searchValueHistorial}
          />
          {(!partidasArancelariasHistorial ||
            partidasArancelariasHistorial.length === 0) && (
            <Typography>La búsqueda no arrojó ningún resultado</Typography>
          )}
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
          loading={loadingSearch || debouncingSearch}
        >
          {searchValue ? (
            <PartidaArancelariaSearchView
              data={partidasArancelarias.map(mapTreeView)}
              expanded={expanded}
              onNodeSelect={handleSelect}
              // onNodeToggle={handleToggleJerarquia}
              highlight={searchValue}
            />
          ) : (
            <PartidaArancelariaView
              data={partidasArancelarias.map(mapTreeView)}
              onNodeSelect={handleSelect}
              onNodeToggle={handleToggle}
              highlight={searchValue}
            />
          )}
        </TabPanel>

        <br />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(PartidaArancelariaSelector);
